class PhotoGallery {
    constructor(item) {
        // Переменные
        this.element = item;
        this.slider = this.element.querySelector('.js-gallery-slider');
        this.slides = this.element.querySelectorAll('.swiper-slide');
        this.images = this.element.querySelectorAll('.photo-gallery__link');
        this.btnPrev = this.element.querySelector('.js-gallery-prev');
        this.btnNext = this.element.querySelector('.js-gallery-next');

        // Функции
        this.setListeners();
    };

    setListeners() {
        const swiper = new Swiper(this.slider, {
            slidesPerView: 'auto',
            spaceBetween: 20,
            navigation: {
                nextEl: this.btnNext,
                prevEl: this.btnPrev,
            },
        });

        this.images.forEach((item, index) => {
            item.addEventListener('click', event => {
                event.preventDefault();
                this.openPhotoSwipe(index);
            });
        })
    }

    openPhotoSwipe(index) {
        const galleryOptions = {
            index: index,
        };

        const links = [];
        this.images.forEach(item => {
            links.push(item.getAttribute('href'));
        });

        const items = links.map(image => {
            return {src: image, w: 1200, h: 800}
        })

        const pswpElement = document.querySelectorAll('.pswp')[0];

        const gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, items, galleryOptions);
        gallery.init();
    };
};

document.querySelectorAll('.js-photo-gallery').forEach((item) => new PhotoGallery(item));
